// extracted by mini-css-extract-plugin
module.exports = {"notification":"notifications-module__notification___2e5Qw"};